export default __webpack_public_path__ + "static/1990-09-01_soundColor_MTS.pdf";